// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1-6u4","label":"Radio_label__2H6WV","checkMark":"Radio_checkMark__1NLyH","disabled":"Radio_disabled__1rfU8"};